export enum CurrencyEnum {
  USD = 'USD',
}
export enum CurrencyActionsEnum {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  RESTORE = 'RESTORE',
}
